
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";
import { DeleteBarcodeNoScanLineItemRequest } from "@/models/api/barcodeSystem/barcodeOrders/deleteBarcodeNoScanLineItem";
import { formatBool } from "@/utils";

const barcodeSystemModule = getModule(BarcodeSystemModule);

@Component
export default class BarcodeNoScanLineItemDelete extends Vue {
  @Prop({ default: false })
  loading: boolean;

  @Prop({ default: null })
  deleteBarcodeNoScanLineItemRequest: DeleteBarcodeNoScanLineItemRequest;

  get formatDamaged()
  {
    return formatBool(this.deleteBarcodeNoScanLineItemRequest.damaged);
  }

  set formatDamaged(val)
  {

  }

  formatBool(val)
  {
    formatBool(val)
  }
}
